<template>
  <div class="index">
    <div class="top">
      <div class="top-left">
        <div class="right-box">
          <div id="myChart2" :style="{width: '245px', height: '100%'}"></div>
          <div class="info-box">
            <div class="title"><div>我的订单 <span v-if="roles.includes('LABORDER_EDIT')" class="btn" @click="goSelect">在线下单 ></span></div></div>
            <div class="myorderStatus">
              <div v-for="(item, index) in myorder" :key="item.name" :class="index==2?'margin-bottom15':''">
              
                <div v-if="item.state.includes('1')" class="compatible125">
                  <div>
                    <i :class="bgColors[index]+' color-box'"></i>
                  </div>
                  <div style="display: flex;">
                    <span >{{item.name}}：<i @click="goOrder(item.state)">{{item.value}}</i></span>
                    <span  v-if="item.state.includes('1')">（退回：<i @click="goOrder('3')">{{Object.keys(withdraw)[0]}}</i>）</span>
                  </div>
                </div>
                <p v-else>
                  <i :class="bgColors[index]+' color-box'"></i>
                  <span >{{item.name}}：<i @click="goOrder(item.state)">{{item.value}}</i></span>
                  <span  v-if="item.state.includes('6')">（变更：<i @click="goOrder('8')">{{Object.keys(changeOrder)[0]}}</i>）</span>
                </p>
              </div>
              <div class="Backplane" v-if="myorder.length>0" style="width: 200px;">
                <span class="reminder">待办</span>
              </div>
            </div>
          </div>
        </div>
        <div class="left-box">
          <div id="myChart" style="width: 245px;height: 100%"></div>
          <div class="info-box">
            <p class="title" style="height:40px; line-height:40px;">我的积分</p>
            <p class="gary">历史消费积分：{{historyScores ? historyScores.toFixed(2) || 0 : 0}}</p>
            <p>未消费积分：{{allPoints ? allPoints.toFixed(2) || 0 : 0}}</p>
            <p v-for="(item, index) in myScores" :key="item.name" class="integral-compatible125">
              <span>
                <i :class="bgColors[index]+' color-box'"></i>
                {{item.name}}：{{item.value ? item.value.toFixed(2) : 0}}
              </span>
              <span  class="test-num" v-if="item.name == '冻结积分'">检测中：{{testPoints}}</span>
            </p>
          </div>
        </div>
      </div>
      <div class="top-right" v-if="leftTopData">
        <div class="bgc3db9dc" @click="goagency(2)" >
          <p class="title">证书数</p>
          <p class="num"> {{leftTopData.certNum}} <span>份</span> </p>
          <p class="prompt-text">今日新增 {{leftTopData.newsCertNum}} 份</p>
        </div>
        <div class="bgc5cd580" @click="goagency(4)">
          <p class="title">关键件</p>
          <p class="num"> {{leftTopData.keyCertNum}} <span>份</span> </p>
          <p class="prompt-text">今日新增 {{leftTopData.newKeyCertNum}} 份</p>
          </div>
        <div class="bgcf1b53d" @click="goagency(3)">
          <p class="title">无证报告</p>
          <p class="num">{{leftTopData.reportNum}} <span>份</span> </p>
          <p class="prompt-text">今日新增 {{leftTopData.newsReportNum}} 份</p>
          </div>
        <div class="bgcff5d48">
          <p class="title">即将到期证书</p>
          <p class="num">{{leftTopData.soonExpireNum}} <span>份</span> </p>
          <p class="prompt-text">今日新增 {{leftTopData.expireNum}} 份</p>
        </div>
      </div>
    </div>
    <div class="bottom">
      <div class="bottom-left">
        <p class="title">合作实验室</p>
        <ul>
          <li class="img-list" v-for="item in laboratoryList" :key="item.id">
            <img class="img" v-if="item.logo" :src="item.logo.attachmentUrl" alt="" >
            <div class="mask">
                <a-button size="large" type="primary" @click="gocreat(item.id)">去下单</a-button>
            </div>
          </li>
        </ul>
      </div>
      <div class="bottom-right">
        <p class="title">检测中订单<span class="btn" @click="goOrder(['6','8'])">更多</span></p>
        <div class="right-main">
          <!-- :rowKey="record => record.deadline" -->
          <a-table
            :columns="columns"
            :dataSource="orderList"
            style="background:#fff;"
            :pagination="false"
          >
            <template slot="orderNumber"></template>
            <template slot="labName"></template>
            <template slot="deadline" slot-scope="record">
              <span >{{record.deadline | formatDate}}</span>
              <i v-if="record.expire==='即将到期'" style="color:#f1b53d;"> {{record.expire}}</i>
              <i v-if="record.expire==='已超期'" style="color:#ff0036; font-size: 10px;"> {{record.expire}}</i>
            </template>
          </a-table>
        </div>
      </div>
    </div>
    <div class="right-menu">
        <ul>
            <li class="we-chat">
                <i class="iconfont icon">&#xe617;</i>
                <span class="max-text"><i class="iconfont">&#xe617;</i>微信咨询</span>
                <div class="we-img">
                    <div class="img"></div>
                </div>
            </li>
            <li>
                <i class="iconfont icon">&#xe613;</i>
                <span class="max-text"><i class="iconfont">&#xe613;</i>19906876274</span>
            </li>
            <li onclick="qimoChatClick()">
                <i class="iconfont icon">&#xe612;</i>
                <span class="max-text"><i class="iconfont">&#xe612;</i>在线咨询</span>
            </li>
        </ul>
    </div>
  </div>
</template>

<script>
import {getHomeChartData, getHomeOrderList, enterpriseTop, getHomeLaboratorys} from '@/api/index'
import { creatForm } from '@/api/entrust'
import {formatDate} from '@/utils/date';
const columns = [
  {
    title: "委托单号",
    dataIndex: "orderNumber",
    scopedSlots: { customRender: 'orderNumber' },
    className: 'bgcFFF'
  },
  {
    title: '实验室',
    dataIndex: 'labName',
    scopedSlots: { customRender: 'labName' },
    className: 'bgcFFF'
  },
  {
    title: '预计完成时间',
    scopedSlots: { customRender: 'deadline' },
    className: 'bgcFFF'
  },
];

export default {
  components: {},
  data() {
    return {
      columns,
      myScores: [],
      myScoresTableData: [],
      historyScores: 0,
      allPoints: 0,//总积分
      testPoints: 0,
      myorder: [],
      tableLeft: [],
      orderList: [],
      laboratoryList: [],
      formId:0,
      leftTopData:null,
      bgColors:['bgcFAC858', 'bgc73C0DE', 'bgcFFA3A3', 'bgc5470C6', 'bgc91CB74', 'bgcEE6666'],
      roles: [],
      withdraw: 0,
      changeOrder: 0,
    };
  },
  created() {
    let userMsg = this.$store.state.user.user;
    this.roles = userMsg.roles;
    this.getHomeOrderList();
    this.enterpriseTop();
    this.getHomeLaboratorys();
  },
  mounted() {
    this.getHomeChartData();
  },
  methods: {
    goSelect() {
      this.$router.push('/detection/selectLaboratory');
    },
    init() {
      let myChart = this.$echarts.init(document.getElementById('myChart'))
      // 绘制图表
      myChart.setOption({
          tooltip: {
              trigger: 'item'
          },
          // legend: {
          //     top: '10%',
          //     left: 'center'
          // },
          color:['#FAC858', '#73C0DE', '#FFA3A3', '#5470C6', '#91CB74', '#EE6666'],
          series: [
              {
                  type: 'pie',
                  radius: ['35%', '70%'],
                  avoidLabelOverlap: false,
                  itemStyle: {
                      borderRadius: 10,
                      borderColor: '#fff',
                      borderWidth: 1
                  },
                  label: {
                      show: false,
                      position: 'center'
                  },
                  emphasis: {
                      label: {
                          show: true,
                          fontSize: '14',
                          fontWeight: 'bold'
                      }
                  },
                  labelLine: {
                      show: false
                  },
                  // data: [
                  //     {value: this.availableScores, name: "可用积分"},
                  //     {value: this.freezeScores, name: "冻结积分"},
                  // ]
                  data: this.myScoresTableData
              }
          ]
      });
    },
    chart2() {
      let myChart = this.$echarts.init(document.getElementById('myChart2'))
      // 绘制图表
      myChart.setOption({
          tooltip: {
              trigger: 'item'
          },
          // legend: {
          //     top: '6%',
          //     left: 'center'
          // },
          color:['#FAC858', '#73C0DE', '#FFA3A3', '#5470C6', '#91CB74', '#EE6666'],
          series: [
              {
                  type: 'pie',
                  radius: ['35%', '70%'],
                  avoidLabelOverlap: false,
                  itemStyle: {
                      borderRadius: 10,
                      borderColor: '#fff',
                      borderWidth: 1
                  },
                  label: {
                      show: false,
                      position: 'center',
                  },
                  emphasis: {
                      label: {
                          show: true,
                          fontSize: '14',
                          fontWeight: 'bold'
                      }
                  },
                  labelLine: {
                      show: false
                  },
                  data: this.tableLeft
              }
          ]
      });
    },
    // 获取图表数据
    getHomeChartData() {
      getHomeChartData()
        .then(res => {
          let rightArr = res.right;
          let leftArr = res.left;
          this.myScores = rightArr;
          this.myScoresTableData = rightArr;
          this.myorder = leftArr;
          this.tableLeft = leftArr;
          this.historyScores = res.historyNum;
          this.testPoints = res.cheack;
          this.allPoints = res.allPoints;
          this.withdraw = res.withdraw;
          this.changeOrder = res.change;
          this.init();
          this.chart2();
        })
        .catch(error => {
          console.log(error);
        })
    },
    // 获取检测中的订单列表
    getHomeOrderList() {
      getHomeOrderList()
        .then(res => {
          this.orderList = res;
        })
        .catch(error => {
          console.log(error);
        })
    },
    // 首页跳转至分类订单页
    goOrder(value) {
      this.$router.push({ name: 'orderManage', params: {'state': value}})
    },
    // 创建订单
    creatForm(id) {
      // id 为实验室的 id
        let params = {
            'labId': id
        }
        return new Promise(resolve => {
            creatForm(params)
                .then(res => {
                    this.formId = res;
                    resolve();
                })
                .catch(error => {
                    console.log(error);
                })
        })
    },
    // 首页跳转至订单页（创建新的订单）
    gocreat(id) {
      this.creatForm(id).then(() => {
        this.$router.push({path: '/detection/creatOrder', query: {'id': this.formId}});
      })
    },
    // 右上角数据
    enterpriseTop() {
      enterpriseTop()
        .then(res => {
          // console.log("右上角数据：", res);
          this.leftTopData = res;
        })
        .catch(error => {
          console.log(error);
        })
    },
    goagency(type){
      let userMsg = this.$store.state.user.user;
      let roles = userMsg.roles;
      if(type==2 && roles.includes('CERTIFICATE_SELECT')){
        this.$router.push('/product/manage')
      } else if(type==3 && roles.includes('REPORT_SELECT')){
        this.$router.push('/product/report')
      } else if (type == 4 && roles.includes('KEYPIECECERTIFICATE_SELECT')) {
        this.$router.push('/product/keyPartCertificate')
      }
    },
    getHomeLaboratorys() {
      getHomeLaboratorys()
        .then(res => {
          // console.log("res：", res);
          this.laboratoryList = res;
        })
        .catch(error => {
          console.log(error);
        })
    }

  },
  watch: {
   
  },
  filters: {
    formatDate(time) {
      var date = new Date(time);
      return formatDate(date, "yyyy-MM-dd");
    },
  }
};
</script>
<style lang="less" scoped>
   @keyframes gradientBG {
      0% {
        background-position: 0% 50%;
      }
      50% {
        background-position: 100% 50%;
      }
      100% {
        background-position: 0% 50%;
      }
  }
.index {
  height: 100%;
  background-color: #fff;
  padding: 40px 30px 20px 30px;
  .title {
      font-size: 18px;
      font-weight: 700;
      display: flex;
      align-items: center;
      justify-content: space-between;
  }
  .top {
    display: flex;
    justify-content: space-between;
    height: 300px;
    .top-left {
      width: 65%;
      height: 100%;
      display: flex;
      justify-content: space-between;
      border-radius: 4px;
      border: 1px solid #ebeef5;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.102);
      overflow: hidden;
      .left-box, .right-box {
        width: 49%;
        height: 100%;
        display: flex;
        justify-content: flex-start;
        // align-items: center;
        .info-box {
          flex: 1;
          margin-left: 10px;
          padding-top: 40px;
          p {
            width: 100%;
            margin-bottom: 8px;
            span {
              i {
                color: #409eff;
                cursor: pointer;
              }
            }
            .test-num {
              display: inline-block;
              background-color: #409eff;
              color: #fff;
              padding: 2px 5px;
              border-radius: 3px;
              margin-left: 6px;
              font-size: 12px;
            }
          }
          // .gary {
          //   background-color: #f2f2f2;
          // }
        }
        #myChart {
          height: 100%;
        }
      }
      .right-box {
        width: 50%;
        .info-box {
          width: 49%;
          .title {
            .btn {
                display: inline-block;
                padding: 3px 4px;
                text-align: center;
                font-size: 14px;
                border-radius: 3px;
                cursor: pointer;
                color: #fff;
                box-shadow: 0 4px 4px #BBEAFF, 0 1px 6px #BBEAFF;
                background: linear-gradient(-45deg, #409eff, #93d5dc, #23a6d5, #23d5ab);
                background-size: 400% 400%;
                animation: gradientBG 5s ease infinite;
                margin-left: 10px;
            }
          }
        }
      }
    }
    .top-right {
      display: flex;
      justify-content: space-between;
      align-content: space-around;
      flex-wrap: wrap;
      width: 31%;
      div {
        width: 47%;
        height: 39%;
        padding: 15px 20px 10px;
        border-radius: 6px;
        cursor: pointer;        
        .title {
          font-size: 16px;
          font-weight: bold;
        }
        .num {
          text-align: center;
          font-size: 24px;
          font-weight: bold;
          span {
            font-weight: 400;
            font-size: 14px;
          }
        }
        .prompt-text{
          margin-top: 7px;
          color: #666;
        }
      }
    }
  }
  .bottom {
    margin-top: 40px;
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin-bottom: 20px;
    .title {
      margin-bottom: 10px;
      .btn {
          display: inline-block;
          color: #409eff;
          cursor: pointer;
          border-radius: 3px;
          text-align: center;
          font-size: 16px;
          box-sizing: border-box;
      }
    }
    .bottom-left {
      width: 65%;
      ul {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        flex-wrap: wrap;
        .img-list {
            display: flex;
            margin-bottom: 2%;
            margin-right: 2%;
            justify-content: center;
            align-items: center;
            width: 32%;
            height: 170px;
            border-radius: 10px;
            text-align: center;
            position: relative;
            cursor: pointer;
            overflow: hidden;
            box-shadow: 0px 1px 4px 0px rgba(70, 70, 70, 0.4);
            img {
              width: 100%;
              height: 100%;
            }
            .mask {
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              background: rgba(101, 101, 101, 0.6);
              color: #ffffff;
              opacity: 0;
              font-size: 24px;
              line-height: 170px;
          }
      }
      .img-list:hover .mask {
        opacity: 1;           
      }
    }
    }
    .bottom-right {
      width: 31%;
      height: auto;
      .right-main {
          box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.102);
          border-radius: 4px;
          border: 1px solid #ebeef5;
          overflow: hidden;
          padding: 25px;
          height: 86%;
          box-sizing: border-box;
      }
      ul {
        margin-top: 20px;
        .orderHeader {
          color: #999;
          span {
            display: inline-block;
            margin-right: 10px;
          }
        }
        .orderItem {
          p {
            display: inline-block;
          }
        }
      }
      
    }
  }
  .right-menu {
    width: 45px;
    border-radius: 4px;
    min-height: 350px;
    /* display: flex; */
      /* -webkit-box-orient: vertical;
      -webkit-box-direction: normal;
      -ms-flex-direction: column;
    flex-direction: column; */
    position: fixed;
    z-index: 999;
    right: 0;
    bottom: 200px;
    li {
      width: 45px;
      height: 48px;
      line-height: 48px;
      background: rgba(53,63,88,0.66);
      border-bottom: 1px solid rgba(255, 255, 255, 0.4);
      cursor: pointer;
      color: #fff;
      text-align: center;
      font-size: 16px;
      position: relative;
      .we-img {
        position: absolute;
        width: 120px;
        height: 120px;
        left: -230px;
        top: 0;
        background-color: #fff;
        border-radius: 10px;
        display: none;
        .img {
          position: absolute;
          width: 90%;
          height: 90%;
          background: url('../../assets/images/small-public.png') center no-repeat;
          background-size: 100% 100%;
          left: 50%;
          top: 50%;
          transform: translateX(-50%) translateY(-50%);
        }
      }
      .icon {
        position: absolute;
        z-index: 2;
        font-size: 24px;
        display: block;
        width: 100%;
        height: 100%;
        background: rgba(53,63,88,0.66);
        left: 0;
        top: 0;
        transition: left 1.2s;
      }
      .max-text {
        display: block;
        position: absolute;
        width: 160px;
        height: 48px;
        line-height: 48px;
        z-index: 3;
        left: 60px;
        top: -1px;
        background-image: linear-gradient(to right, rgb(90,211,151), rgba(0,175,131,1));
        color: #fff;
        border-radius: 5px 0 0 5px;
        font-size: 18px;
        transition: left 1s;
        padding: 0 10px;
        box-sizing: border-box;
        i{
          vertical-align: middle;
          margin-right: 10px;
        }
      }
    }
    li:last-child {
      border: none;
    }
    li:hover .max-text{
      left: -115px;
    }
    li:hover .icon {
      left: -20px;
    }
    .we-chat:hover .we-img{
      display: block;
    }
  }
}
th .bgcFFF {
  background-color: #fff!important;
}
.myorderStatus {
  position: relative;
  margin-top: 20px;
  z-index: 96;
  .Backplane {
    position: absolute;
    top: -5px;
    left: -6px;
    z-index: -1;
    width: 81%;
    height: 90px;
    border-radius: 4px;
    border: 1px solid #ebeef5;
    -webkit-box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
    box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
    overflow: hidden;
    .reminder {
      position: absolute;
      bottom: 0;
      right: 10px;
      z-index: 80;
      font-size: 25px;
      font-weight: 900;
      color: rgba(0, 0, 0, 0.102);
    }
  }
}

/deep/.ant-table-placeholder {
  border: none;
  
}
/deep/.ant-table-tbody > tr > td {
  border-bottom: 1px dashed #eee;
}
/deep/.ant-table-thead > tr > th {
  border: none;
  font-size: 16px;
}
.bgc3db9dc {
  background-color: rgba(231, 244, 255, 0.88);
  box-shadow: 0 2px 12px 0 rgba(231, 244, 255, 0.88);
}
.bgc5cd580 {
  background-color:rgba(210, 240, 199, 0.7);
  box-shadow: 0 2px 12px 0 rgba(210, 240, 199, 0.7);
}
.bgcf1b53d {
  background-color:rgba(255, 221, 156, 1);
  box-shadow: 0 2px 12px 0 rgba(255, 221, 156, 0.67);
}
.bgcff5d48 {
  background-color:rgba(255, 185, 170, 0.56);
  box-shadow: 0 2px 12px 0 rgba(255, 185, 170, 0.56);
}
.bgcFAC858 {
  background-color: #FAC858!important;
}
.bgc73C0DE {
  background-color: #73C0DE!important;
}
.bgcFFA3A3 {
  background-color: #FFA3A3!important;
}
.bgc5470C6 {
  background-color: #5470C6!important;
}
.bgc91CB74 {
  background-color: #91CB74!important;
}

.bgcEE6666 {
  background-color: #EE6666!important;
}

.color-box {
  display: inline-block;
  border-radius: 3px;
  margin-right: 5px;
  width: 15px;
  height: 10px;
}
.bottom-left ul li.img-list:nth-child(3n) {
  margin-right: 0px!important;
  border: 1px solid #fff;
}
.margin-bottom15 {
  margin-bottom: 15px!important;
}
.compatible125 {
  display: flex;
  margin-bottom: 10px;
  span {
    display: block;
    white-space: nowrap;
    i {
      color: #409eff;
      cursor: pointer;
    }
  }
}
</style>
<style lang="less">
th.bgcFFF {
  background-color: #fff!important;
}

</style>
